<template>
    <div id="app">
        <ReadOnlyBanner />
        <router-view />
        <portal-target name="overlay-portal" multiple />
    </div>
</template>

<script>
import ReadOnlyBanner from '@/components/ReadOnlyBanner.vue';

export default {
    name: 'App',
    components: { ReadOnlyBanner },
};
</script>

<style lang="scss" scoped>
#app {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
</style>
